// Utility function for printing HTML elements
export const printElement = (element) => {
  const printWindow = window.open('', '_blank');
  printWindow.document.write(`
    <html>
      <head>
        <title>Print Proposal</title>
        <link href="https://cdn.jsdelivr.net/npm/tailwindcss@2.2.19/dist/tailwind.min.css" rel="stylesheet">
        <style>
          @media print {
            body { 
              padding: 20px;
              font-size: 12pt;
            }
            .no-print { 
              display: none; 
            }
            table { 
              width: 100%;
              border-collapse: collapse;
              margin-bottom: 1rem;
            }
            th, td { 
              border: 1px solid #e5e7eb;
              padding: 8px;
              text-align: left;
            }
            th { 
              background-color: #f3f4f6;
              font-weight: bold;
            }
            .page-break {
              page-break-before: always;
            }
            .proposal-header {
              margin-bottom: 2rem;
            }
            .proposal-footer {
              margin-top: 2rem;
              border-top: 1px solid #e5e7eb;
              padding-top: 1rem;
            }
            @page {
              margin: 0.5in;
            }
          }
        </style>
      </head>
      <body>
        ${element.outerHTML}
      </body>
    </html>
  `);
  printWindow.document.close();
  printWindow.focus();
  setTimeout(() => {
    printWindow.print();
    printWindow.close();
  }, 250);
}; 